import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { SelectField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';
import { determineRuleType } from 'modules/jsonRulesCriterias/businessCriteria';
import { FACT_NAMES_STRING, FACT_NAMES_NUMERIC } from '@trnsact/business-criteria';
import { booleanOptions } from '../../../../constants';
import { FinanceProgramForm } from '../../../../schema';
import { StringFieldsByRule } from './StringFieldsByRule';
import { NumberFieldsByRule } from './NumberFieldsByRule';
import { AllRules, ConditionsFieldsTypes } from '../../../../types';
import { SelectOption } from 'global';

interface Props {
  index: number;
  dealerOptions?: SelectOption[];
}

export const ConditionsFieldsByRuleType = ({ index, dealerOptions = [] }: Props) => {
  const { control } = useFormContext<FinanceProgramForm>();
  const { program } = useWatch<FinanceProgramForm>({ control });

  const rule = program?.first?.criteria?.conditions?.[index]?.fact! as AllRules;

  const ruleType = determineRuleType(rule);

  const renderFields: Record<ConditionsFieldsTypes, ReactNode> = {
    [ConditionsFieldsTypes.Boolean]: (
      <SelectField
        label="Select"
        control={control}
        options={booleanOptions}
        name={`program.first.criteria.conditions.${index}.boolean.value`}
      />
    ),
    [ConditionsFieldsTypes.Number]: <NumberFieldsByRule type={rule as FACT_NAMES_NUMERIC} index={index} />,
    [ConditionsFieldsTypes.String]: (
      <StringFieldsByRule type={rule as FACT_NAMES_STRING} index={index} dealerOptions={dealerOptions} />
    ),
  };

  return <Box className="conditionsFields">{renderFields[ruleType]}</Box>;
};
